import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useCurrentPlatformId from '../route/useCurrentPlatformId';

import useCurrentHref from './useCurrentHref';

export default function usePlatformNavigator() {
  const navigate = useNavigate();
  const platformId = useCurrentPlatformId();
  return useMemo(
    () => ({
      platformSettings: () => {
        navigate(`/o/${platformId}/settings`);
      },
      showWorkflow: (id: string) => {
        navigate(`/o/${platformId}/workflows/${id}`);
      },
      listWorkflows: () => {
        navigate(`/o/${platformId}/workflows`);
      },
      listTemplates: () => {
        navigate(`/o/${platformId}/templates`);
      },
      showEmailMessage: (id: string, { modelIds }: { modelIds: string[] | null }) => {
        navigate(`/o/${platformId}/events/${id}`, { state: { modelIds } });
      },
      showWorkflowRun: (id: string, { modelIds }: { modelIds: string[] | null }) => {
        navigate(`/o/${platformId}/workflow-runs/${id}`, { state: { modelIds } });
      },
      showDomainName: (id: string) => {
        navigate(`/o/${platformId}/domain-names/${id}`);
      },
      showContact: (id: string, { modelIds }: { modelIds: string[] | null }) => {
        navigate(`/o/${platformId}/contacts/${id}`, { state: { modelIds } });
      },
      showContactsGroup: (id: string) => {
        navigate(`/o/${platformId}/groups/${id}`);
      },
    }),
    [navigate, platformId]
  );
}

export function getPlatformHref(platformId: string) {
  return `/o/${platformId}`;
}

export function useShowTemplateNavigate() {
  const backLinkHref = useCurrentHref();
  const navigate = useNavigate();
  const { platformId } = useParams<{ platformId: string }>();
  return useCallback(
    (templateId: string) => {
      navigate(`/o/${platformId}/templates/${templateId}`, { state: { backLinkHref } });
    },
    [platformId, backLinkHref, navigate]
  );
}
